import React from 'react';

const ReportConversionContext = React.createContext({});
ReportConversionContext.displayName = 'ReportConversionContext';

export default ReportConversionContext;
